// extracted by mini-css-extract-plugin
export default {"gender-selector-container":"catalog-DepartmentSelector-module__gender-selector-container","correctedTerm":"catalog-DepartmentSelector-module__correctedTerm"};